﻿/* global currentLanguage */

"use strict";

$(document).ready(function () {
    const navigation = new Navigation();
    navigation.init();
});

class Navigation {
    constructor() {
        this.setWithExpiry = this.setWithExpiry.bind(this);
        this.mainNavigationCacheKey = "hypertherm-main-nav";
    }

    init() {
        this.mainNavigationCntnr = $("#main-navigation");
        let cachedMainNav = this.getWithExpiry(this.mainNavigationCacheKey);

        if (!this.mainNavigationCntnr.length)
            return;

        if (cachedMainNav) {
            this.mainNavigationCntnr.append(cachedMainNav);
        } else {
            this.loadNavigation();
        }
    }

    setWithExpiry(key, value, seconds) {
        let now = new Date();

        // `item` is an object which contains the original value as well as the time when it's supposed to expire
        let item = {
            value: value,
            expiry: now.getTime() + seconds * 1000,
            language: currentLanguage
        };

        localStorage.setItem(key, JSON.stringify(item));
    }

    getWithExpiry(key) {
        let itemStr = localStorage.getItem(key);

        // if the item doesn't exist, return null
        if (!itemStr) {
            return null;
        }

        let item = JSON.parse(itemStr);
        let now = new Date();

        // compare the expiry time of the item with the current time
        if (now.getTime() > item.expiry || currentLanguage !== item.language) {
            // If the item is expired, delete the item from storage and return null
            localStorage.removeItem(key);
            return null;
        }

        return item.value;
    }

    loadNavigation() {
        this.loadMainNavigation();
    }

    loadMainNavigation() {
        const self = this;
        $.ajax({
            url: "/" + currentLanguage + "/mainnavigation/load",
            headers: { "Accept-Language": currentLanguage },
            success: function (data) {
                self.setWithExpiry(self.mainNavigationCacheKey, data, 1200);
                self.mainNavigationCntnr.append(data);
            },
            async: false
        });
    }
}
